import React, { useContext, useState } from "react";
import UploadEquipmentsModal from "./UploadEquipmentModal";
import { EssealDataTable } from "esseal-data-table";
import equipmentColumns from "./equipmentColumns";
import { Button } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import DetailsDrawer from "./DetailsDrawer";
import { isUndefined } from "lodash";
import EditIcon from "@mui/icons-material/Edit";
import { CompanyResource, PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";
import BulkImportResourcesModal from "@/shared-components/BulkImportResourcesModal";
import PermissionContext from "@/Contexts/Permissions";
import RequestPermissionTooltip from "@/components/RequestPermissionTooltip";

interface CompanyEquipmentsTableProps {
  loading: boolean;
  data: CompanyResource[];
}
const CompanyEquipmentsTable: React.FC<CompanyEquipmentsTableProps> = ({
  data,
  loading,
}) => {

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState<CompanyResource | undefined>(undefined);
  const [showEquipmentDetails, setShowEquipmentDetails] = useState<boolean>(false);

  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const { Create, Manage } = PermissionActionEnum;
  const { EquipmentManagement } = PermissionEntityEnum;
  const hasCreatePermission = canPerformAction(Create, EquipmentManagement);
  const hasManagePermission = canPerformAction(Manage, EquipmentManagement);

  const createPermissionTooltipProps = {
    hasPermission: hasCreatePermission,
    requiredPermission: { action: Create, entity: EquipmentManagement },
    checkRequestExists,
    onRequest: requestPermission,
  }

  return (
    <React.Fragment>
      <EssealDataTable
        rows={data}
        columns={equipmentColumns}
        loading={loading}
        checkboxSelection={false}
        pagination={true}
        pageSize={25}
        // Actions & Events
        rowActions={(row) => [
          {
            label: 'View',
            icon: <Visibility fontSize="small" />,
            tooltip: 'View',
            onClick: () => {
              setSelectedEquipment(row);
              setShowEquipmentDetails(true);
            }
          },
          {
            label: 'Edit',
            icon: <EditIcon fontSize="small" color={hasManagePermission ? "primary" : "disabled"} />,
            tooltip: 'Edit',
            disabled: !hasManagePermission,
            onClick: () => {
              if (!hasManagePermission) return;
              setSelectedEquipment(row);
              setShowCreateModal(true);
            }
          }
        ]}
        toolbar={
          <RequestPermissionTooltip {...createPermissionTooltipProps}>
            <Button
              disabled={!hasCreatePermission}
              onClick={() => setShowCreateModal(true)}
            >
              + Add New
            </Button>
          </RequestPermissionTooltip>
        }
      />

      {showUploadModal && (
        <UploadEquipmentsModal
          handleClose={() => setShowUploadModal(false)}
        />
      )}

      {showCreateModal &&
        <BulkImportResourcesModal importType="equipment" handleClose={() => setShowCreateModal(false)} />
      }

      <DetailsDrawer
        open={!isUndefined(selectedEquipment) && showEquipmentDetails}
        onClose={() => {
          setShowEquipmentDetails(false);
          setSelectedEquipment(undefined);
        }}
        equipment={selectedEquipment}
      />
    </React.Fragment>
  );
};

export default CompanyEquipmentsTable;
